import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Dayjs } from 'dayjs';
import { getCallStats } from 'api/salesAnalytics/getCallStats';

interface CallStatsGraphProps {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
}

const CallStatsGraph: React.FC<CallStatsGraphProps> = ({ startDate, endDate }) => {
  const [chartData, setChartData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  
  useEffect(() => {
    const fetchCallStats = async () => {
      if (startDate && endDate) {
        try {
          setLoading(true);
          console.log('Fetching email stats with:', { startDate, endDate });
          const response = await getCallStats(startDate.toDate(), endDate.toDate());
          console.log('API Response:', response);
          setChartData(response || []);
        } catch (error) {
          console.error('Error fetching email stats:', error);
        } finally {
          setLoading(false);
        }
      } else {
        console.warn('Start date or end date is null. Skipping API call.');
      }
    };

    fetchCallStats();
  }, [startDate, endDate]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    // Set a fixed height (300px) to prevent the graph from growing vertically indefinitely.
    <Box sx={{ width: '100%', height: 300 }}>
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis
              label={{
                value: 'calls',
                angle: -90,
                position: 'insideLeft',
                offset: -10,
              }}
            />
            <Tooltip />
            <Legend />
            <Bar dataKey="successfulCalls" fill="#8FBFDA" />
            <Bar dataKey="noResponseCalls" fill="#67778a" />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Typography align="center">No data available</Typography>
      )}
    </Box>
  );
};

export default CallStatsGraph;
